(function () {
  function init() {
    // Only on product pages
    var mainForm = document.querySelector('product-form');
    if (!mainForm) return;
    var mainBtn = mainForm.querySelector('[name="add"]');
    if (!mainBtn) return;
    if (document.getElementById('dw-sticky-bar')) return;

    var css = `
      #dw-sticky-bar {
        position: fixed; bottom: 0; left: 0; right: 0; z-index: 8999;
        background: #111; border-top: 2px solid #e74c3c;
        padding: 10px 16px; display: flex; align-items: center;
        gap: 10px; box-shadow: 0 -4px 20px rgba(0,0,0,.5);
        transform: translateY(100%); transition: transform .3s ease;
        font-family: inherit;
      }
      #dw-sticky-bar.dw-sb-visible { transform: translateY(0); }
      #dw-sb-info { flex: 1; min-width: 0; }
      #dw-sb-title {
        font-size: 13px; font-weight: 600; color: #fff;
        white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
      }
      #dw-sb-price { font-size: 15px; font-weight: 800; color: #e74c3c; }
      #dw-sb-price s { font-size: 12px; color: #888; font-weight: 400; margin-right: 4px; }
      #dw-sb-add {
        background: linear-gradient(135deg,#c0392b,#e74c3c);
        color: #fff; border: none; border-radius: 8px;
        padding: 11px 16px; font-size: 13px; font-weight: 700;
        cursor: pointer; font-family: inherit; white-space: nowrap;
        flex-shrink: 0;
      }
      #dw-sb-add:hover { opacity: .9; }
      #dw-sb-checkout {
        background: #f1c40f; color: #111; border: none; border-radius: 8px;
        padding: 11px 16px; font-size: 13px; font-weight: 700;
        cursor: pointer; font-family: inherit; white-space: nowrap;
        flex-shrink: 0;
      }
      #dw-sb-checkout:hover { opacity: .9; }
      #dw-sb-add.dw-adding {
        opacity: .7; pointer-events: none;
      }
      #dw-sb-add.dw-added {
        background: #27ae60;
      }
      @media (max-width: 480px) {
        #dw-sb-checkout { display: none; }
        #dw-sb-add { padding: 11px 12px; font-size: 12px; }
      }
    `;

    var styleEl = document.createElement('style');
    styleEl.textContent = css;
    document.head.appendChild(styleEl);

    // Get current product info
    function getTitle() {
      var el = document.querySelector('.product__title h1, .product__title');
      return el ? el.textContent.trim().substring(0, 60) : '';
    }
    function getPriceHtml() {
      var sale = document.querySelector('.price__sale .price-item--sale');
      var compare = document.querySelector('.price__sale .price-item--regular');
      var regular = document.querySelector('.price__regular .price-item--regular');
      if (sale) {
        return (compare ? '<s>' + compare.textContent.trim() + '</s> ' : '') + sale.textContent.trim();
      }
      return regular ? regular.textContent.trim() : '';
    }

    var bar = document.createElement('div');
    bar.id = 'dw-sticky-bar';
    bar.innerHTML =
      '<div id="dw-sb-info">' +
        '<div id="dw-sb-title">' + getTitle() + '</div>' +
        '<div id="dw-sb-price">' + getPriceHtml() + '</div>' +
      '</div>' +
      '<button id="dw-sb-add">🛒 In den Warenkorb</button>' +
      '<button id="dw-sb-checkout">🔒 Sicher zur Kasse</button>';
    document.body.appendChild(bar);

    // Update price dynamically when variant changes
    document.addEventListener('variant:change', function() {
      document.getElementById('dw-sb-price').innerHTML = getPriceHtml();
    });

    // Show/hide based on main button visibility
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        bar.classList.toggle('dw-sb-visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
    observer.observe(mainBtn);

    // Add to cart click
    document.getElementById('dw-sb-add').addEventListener('click', function() {
      var addBtn = document.getElementById('dw-sb-add');
      addBtn.classList.add('dw-adding');
      addBtn.textContent = 'Wird hinzugefügt...';

      // Get variant ID and quantity from the real form
      var variantInput = mainForm.querySelector('[name="id"]');
      var qtyInput = mainForm.querySelector('[name="quantity"]');
      var variantId = variantInput ? variantInput.value : '';
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(function(r) { return r.json(); }).then(function() {
        addBtn.classList.remove('dw-adding');
        addBtn.classList.add('dw-added');
        addBtn.textContent = '✅ Hinzugefügt!';
        // Update cart count if possible
        var cartCount = document.querySelector('.cart-count-bubble span');
        if (cartCount) cartCount.textContent = parseInt(cartCount.textContent || '0') + qty;
        setTimeout(function() {
          addBtn.classList.remove('dw-added');
          addBtn.innerHTML = '🛒 In den Warenkorb';
        }, 2000);
      }).catch(function() {
        // Fallback: click the real button
        mainBtn.click();
        addBtn.classList.remove('dw-adding');
        addBtn.innerHTML = '🛒 In den Warenkorb';
      });
    });

    // Checkout click
    document.getElementById('dw-sb-checkout').addEventListener('click', function() {
      var variantInput = mainForm.querySelector('[name="id"]');
      var qtyInput = mainForm.querySelector('[name="quantity"]');
      var variantId = variantInput ? variantInput.value : '';
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(function() {
        window.location.href = '/checkout';
      }).catch(function() {
        window.location.href = '/checkout';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();